import { Clock } from 'lucide-react';

interface ComingSoonProps {
  title?: string;
  message?: string;
}

export const ComingSoon = ({
  title = 'Coming Soon',
  message = "We're working on this. Check back later.",
}: ComingSoonProps) => {
  return (
    <div className="flex-1 flex items-center justify-center">
      <div className="text-center max-w-sm">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-teamcare-cyan/10 rounded-full flex items-center justify-center">
            <Clock size={32} className="text-teamcare-cyan" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-secondary-900 mb-2">{title}</h1>
        <p className="text-secondary-500">{message}</p>
      </div>
    </div>
  );
};
